import { IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const FileIconButton = styled(IconButton)({
  width: "25px",
});
